// removed by extract-text-webpack-plugin
module.exports = {"downloads__list":"src-components-Downloads----Downloads-module---downloads__list---1h_EC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Downloads/Downloads.module.scss
// module id = 844
// module chunks = 35783957827783